import { isWithinDays } from "@/lib/dayjs/is-within-days";

const NEW_PERIOD_DAYS = 30;

/**
 * 投稿日時から 30 日以内なら true。publishedAt が無ければ false。
 */
export const isWithinNewPeriod = (publishedAt: string | null | undefined): boolean => {
	if (!publishedAt) return false;
	return isWithinDays(publishedAt, NEW_PERIOD_DAYS);
};
